import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "relative z-50 w-full h-full",
  "aria-labelledby": "slide-over-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 bg-gray-700 bg-opacity-80 transition-opacity"
}
const _hoisted_3 = {
  key: 0,
  class: "fixed inset-0 overflow-hidden"
}
const _hoisted_4 = { class: "absolute inset-0 overflow-hidden" }
const _hoisted_5 = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10" }
const _hoisted_6 = { class: "pointer-events-auto relative w-screen max-w-md" }
const _hoisted_7 = { class: "absolute left-0 top-0 -ml-8 flex pr-2 pt-4 sm:-ml-10 sm:pr-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-2.5" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close panel", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "flex h-full flex-col overflow-y-scroll bg-gray-100 py-6 shadow-xl px-6 sm:px-6"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "FORBEREDELSE", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary font-medium text-lg pb-6" }, "De-frost", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z"
  })
], -1)
const _hoisted_16 = {
  key: 0,
  class: "mt-2 text-gray-700 text-sm w-36 text-center"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 1,
  class: "flex h-full flex-col overflow-y-scroll bg-gray-100 py-6 shadow-xl px-6 sm:px-6"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "FORBEREDELSE", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary font-medium text-lg pb-6" }, "De-frost", -1)

import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import imageDeleteIcon from '@/assets/icons/image-delete-icon.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'defrostComponent',
  props: {
  isVisibleDefrost: Boolean
},
  setup(__props) {

const props = __props

const store = useStore()
const route = useRoute()
const id = route.params.id

const defrost = computed(() => store.getters['defrostStore/defrost'])
const details = computed(() => store.getters['bookingStore/booking'])

watch(defrost, (newVal) => {
  if (newVal && newVal.id) {
    newDefrost.value.id = newVal.id
  }
})

const close = () => {
  store.commit('defrostStore/toggleOpen')
}

const selectedFile = ref(null)
const fileInput = ref<File | null>(null)
const triggerFileInput = () => {
  if (fileInput.value !== null) {
    fileInput.value.click()
  }
}

const newDefrost = ref({
  id: defrost?.value?.id,
  imageReference: null
})

const endDefrost = () => {
  store.dispatch('defrostStore/endDefrost', newDefrost.value)
  store.dispatch('bookingStore/bookingDefrostState', 3)
}

const startDefrost = () => {
  store.dispatch('defrostStore/startDefrost', id)
  store.dispatch('bookingStore/bookingDefrostState', 1)
}
const canStartDefrost = computed(() => {
  if (!details.value) {
    return
  }
  const value = details.value.defrostState < 1
  return value
})

const canEndDefrost = computed(() => {
  if (!details.value) {
    return
  }
  const value = details.value.defrostState >= 1
  return value
})

const imageUrl = computed(() => {
  return selectedFile.value ? URL.createObjectURL(selectedFile.value) : null
})

const removeImage = () => {
  selectedFile.value = null
  newDefrost.value.imageReference = null
  if (fileInput.value) {
    fileInput.value.value = ''
  }
}

const handleFileChange = (event: Event) => {
  const files = (event.target as HTMLInputElement).files
  if (files && files.length > 0) {
    const file = files[0]
    selectedFile.value = file
    const reader = new FileReader()
    reader.onload = (e) => {
      newDefrost.value.imageReference = e.target?.result
    }
    reader.readAsDataURL(file)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      "enter-active-class": "ease-in-out duration-500",
      "leave-active-class": "ease-in-out duration-500",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (__props.isVisibleDefrost)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "slide",
      "enter-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "enter-from-class": "translate-x-full",
      "enter-to-class": "translate-x-0",
      "leave-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "leave-from-class": "translate-x-0",
      "leave-to-class": "translate-x-full"
    }, {
      default: _withCtx(() => [
        (__props.isVisibleDefrost)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (close())),
                        type: "button",
                        class: "relative rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                      }, _hoisted_11)
                    ]),
                    (canEndDefrost.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _hoisted_13,
                          _hoisted_14,
                          _createElementVNode("div", {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (triggerFileInput())),
                            class: "p-4 border-dashed border-2 h-36 border-gray-300 rounded flex flex-col items-center justify-center relative overflow-visible mb-4"
                          }, [
                            _hoisted_15,
                            (!selectedFile.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Vælg eller tag evt. billede til dokumentation "))
                              : _createCommentVNode("", true),
                            (imageUrl.value)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: imageUrl.value,
                                  class: "absolute top-0 left-0 w-full h-full object-cover rounded"
                                }, null, 8, _hoisted_17))
                              : _createCommentVNode("", true),
                            (imageUrl.value)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 2,
                                  onClick: _withModifiers(removeImage, ["stop"]),
                                  src: _unref(imageDeleteIcon),
                                  class: "absolute -top-3 -right-3 cursor-pointer"
                                }, null, 8, _hoisted_18))
                              : _createCommentVNode("", true),
                            _createElementVNode("input", {
                              type: "file",
                              ref_key: "fileInput",
                              ref: fileInput,
                              onChange: handleFileChange,
                              accept: "image/*",
                              class: "hidden",
                              capture: "environment"
                            }, null, 544)
                          ]),
                          _createElementVNode("button", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (endDefrost())),
                            disabled: !newDefrost.value.id || !newDefrost.value.imageReference,
                            class: _normalizeClass([{ 'opacity-20 pointer-events-none':!newDefrost.value.id || !newDefrost.value.imageReference }, "flex w-full justify-center rounded-md bg-primary px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary"])
                          }, " Marker som udført ", 10, _hoisted_19)
                        ]))
                      : _createCommentVNode("", true),
                    (canStartDefrost.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _hoisted_21,
                          _hoisted_22,
                          _createElementVNode("button", {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (startDefrost())),
                            class: "flex w-full justify-center rounded-md bg-primary px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary"
                          }, " Start Defrost ")
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})